import es from './es'
import en from './en'
import pt from './pt'

export default {
    es,
    en,
    pt,
}
